import { useDataAttributes } from '../hooks/useDataAttributes/useDataAttributes';
import { DataAttributes } from '../appConfig/dataAttributes';
import { envConfig } from '../appConfig/environments';
import { getEnvironment } from './getEnvironment/getEnvironment';
// eslint-disable-next-line react-hooks/rules-of-hooks
const { baseurl } = useDataAttributes<DataAttributes>();
__webpack_public_path__ = baseurl ?? envConfig[getEnvironment()].baseurl;

export {};
